<template>
  <span class="help-tooltip">
    <button
      type="button"
      class="help-tooltip__trigger"
      aria-label="説明"
      :aria-expanded="shown"
      @click.stop="shown = true"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M6.43231 8.80825C6.56006 8.6805 6.62394 8.525 6.62394 8.34175C6.62394 8.1585 6.56006 8.00359 6.43231 7.877C6.30448 7.7505 6.14906 7.68725 5.96606 7.68725C5.78315 7.68725 5.62777 7.7505 5.49994 7.877C5.3721 8.00359 5.30819 8.1585 5.30819 8.34175C5.30819 8.525 5.3721 8.6805 5.49994 8.80825C5.62777 8.93608 5.78315 9 5.96606 9C6.14906 9 6.30448 8.93608 6.43231 8.80825ZM5.48319 7.075H6.46794C6.46794 6.808 6.49969 6.59433 6.56319 6.434C6.62669 6.27367 6.79931 6.05996 7.08106 5.79288C7.29173 5.58421 7.45906 5.38042 7.58306 5.1815C7.70706 4.98259 7.76906 4.74346 7.76906 4.46413C7.76906 3.99004 7.60023 3.6265 7.26256 3.3735C6.9249 3.1205 6.52273 2.994 6.05606 2.994C5.57306 2.994 5.17869 3.124 4.87294 3.384C4.5671 3.64392 4.35385 3.95488 4.23319 4.31688L5.12394 4.66275C5.1696 4.50875 5.26285 4.34525 5.40369 4.17225C5.5446 3.99925 5.75706 3.91275 6.04106 3.91275C6.28381 3.91275 6.4669 3.98071 6.59031 4.11663C6.71365 4.25246 6.77531 4.40192 6.77531 4.565C6.77531 4.72167 6.72681 4.87142 6.62981 5.01425C6.53281 5.15708 6.41627 5.28504 6.28019 5.39813C5.92152 5.71913 5.69902 5.96646 5.61269 6.14013C5.52635 6.31371 5.48319 6.62534 5.48319 7.075ZM6.00006 11.1016C5.29248 11.1016 4.62856 10.9678 4.00831 10.7001C3.38798 10.4325 2.8484 10.0693 2.38956 9.6105C1.93081 9.15167 1.5676 8.61208 1.29994 7.99175C1.03227 7.3715 0.898438 6.70758 0.898438 6C0.898438 5.29242 1.03227 4.6285 1.29994 4.00825C1.5676 3.38792 1.93081 2.84833 2.38956 2.3895C2.8484 1.93075 3.38798 1.56754 4.00831 1.29988C4.62856 1.03221 5.29248 0.898376 6.00006 0.898376C6.70765 0.898376 7.37156 1.03221 7.99181 1.29988C8.61215 1.56754 9.15173 1.93075 9.61056 2.3895C10.0693 2.84833 10.4325 3.38792 10.7002 4.00825C10.9679 4.6285 11.1017 5.29242 11.1017 6C11.1017 6.70758 10.9679 7.3715 10.7002 7.99175C10.4325 8.61208 10.0693 9.15167 9.61056 9.6105C9.15173 10.0693 8.61215 10.4325 7.99181 10.7001C7.37156 10.9678 6.70765 11.1016 6.00006 11.1016ZM6.00006 9.96413C7.10873 9.96413 8.0466 9.58063 8.81369 8.81363C9.58069 8.04654 9.96419 7.10867 9.96419 6C9.96419 4.89133 9.58069 3.95346 8.81369 3.18638C8.0466 2.41938 7.10873 2.03588 6.00006 2.03588C4.8914 2.03588 3.95352 2.41938 3.18644 3.18638C2.41944 3.95346 2.03594 4.89133 2.03594 6C2.03594 7.10867 2.41944 8.04654 3.18644 8.81363C3.95352 9.58063 4.8914 9.96413 6.00006 9.96413Z"
          fill="#0D76BF"
        />
      </svg>
    </button>
    <teleport to="body">
      <div
        v-if="shown"
        class="p-user-info-modal-overlay"
        @click="shown = false"
      >
        <div
          class="p-user-info-modal"
          role="dialog"
          aria-modal="true"
          @click.stop
        >
          <button
            type="button"
            class="p-user-info-modal__close"
            aria-label="閉じる"
            @click="shown = false"
          >
            <IconBase
              :width="16"
              :height="16"
              view-box="0 0 16 16"
              icon-name="閉じる"
            >
              <IconCancel />
            </IconBase>
          </button>
          <p class="p-user-info-modal__text">{{ text }}</p>
        </div>
      </div>
    </teleport>
  </span>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCancel from "@/common/components/icons/IconCancel.vue";

@Options({
  components: {
    IconBase,
    IconCancel
  },
  props: {
    text: { type: String, required: true }
  }
})
export default class HelpTooltip extends Vue {
  text!: string;
  shown = false;
}
</script>

<style lang="scss" scoped>
.help-tooltip {
  display: inline-flex;
}

.help-tooltip__trigger {
  display: inline-flex;
  padding: 0;
  color: inherit;
  background: none;
  border: none;
  cursor: pointer;
}

.p-user-info-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1999;
  background: rgba(0, 0, 0, 0.4);
}

.p-user-info-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  width: fit-content;
  max-width: min(500px, calc(100vw - #{rem(32)}));
  padding: rem(16);
  background: $common-white;
  border-radius: rem(8);
  box-shadow: 0 rem(8) rem(24) rgba($common-black, 0.2);
  transform: translate(-50%, -50%);

  &__close {
    position: absolute;
    top: rem(-3);
    right: rem(-3);
    display: flex;
    align-items: center;
    justify-content: center;
    width: rem(22);
    height: rem(22);
    padding: rem(3);
    color: $common-black;
    background-color: $common-white;
    border: none;
    border-radius: 50%;
    box-shadow: 0 0 rem(4) rgba($common-black, 0.1);
    cursor: pointer;
  }

  &__text {
    margin: 0;
    overflow-wrap: anywhere;
    line-height: 1.8;
    white-space: pre-line;
  }

  @include sp {
    min-width: min(240px, calc(100vw - #{rem(32)}));

    &__text {
      font-size: rem(14);
    }
  }
}
</style>